import { useEffect, useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useChatMessages } from '@renderer/chat/store/messages'
import { useInvalidateCalendarEvents } from '@renderer/hooks/use-calendar-events'
import { meetingBriefQueryKey } from './meeting-brief-query'

/**
 * Watches the brief's chat conversation for completed `save_meeting_brief`
 * tool calls and refreshes the brief GET plus calendar presence so the
 * body appears immediately instead of waiting for the next poll.
 */
export function useBriefRefreshOnSave(conversationId: string | null | undefined, calendarEventId: string | undefined) {
  const queryClient = useQueryClient()
  const refreshCalendarEvents = useInvalidateCalendarEvents()
  const messages = useChatMessages(conversationId ?? undefined)
  const seenToolCallIds = useRef<Set<string>>(new Set())

  useEffect(() => {
    if (!conversationId || !calendarEventId) return
    for (const message of messages) {
      if (message.role !== 'assistant') continue
      if (!message.toolCalls) continue
      for (const tc of message.toolCalls) {
        if (tc.toolName !== 'save_meeting_brief') continue
        if (tc.status !== 'success') continue
        if (seenToolCallIds.current.has(tc.id)) continue
        seenToolCallIds.current.add(tc.id)
        void queryClient.invalidateQueries({ queryKey: meetingBriefQueryKey(calendarEventId) })
        refreshCalendarEvents()
      }
    }
  }, [messages, conversationId, calendarEventId, queryClient, refreshCalendarEvents])
}
